import type { TranslateService } from '@ngx-translate/core';
import * as dayjs from 'dayjs';
import * as localizedFormat from 'dayjs/plugin/localizedFormat';
import * as localeData from 'dayjs/plugin/localeData';
dayjs.extend(localizedFormat);
dayjs.extend(localeData);
import { lastValueFrom } from 'rxjs';
import { upgradeNg1Dependency } from '@go-modules/common/ng1-upgrade-factory';
import type { tmh } from 'angular-dynamic-locale';

import 'dayjs/locale/nl.js';
import 'dayjs/locale/en.js';

export enum Language {
	NL = 'nl',
	EN = 'en' // Ensure this is always last
}

export class GoLocalizeHelperService {

	public static readonly NG1_INJECTION_NAME = 'goLocalizeHelper' as const;

	/** @ngInject */
	constructor (
		private $translate: angular.translate.ITranslateService,
		private tmhDynamicLocale: tmh.IDynamicLocale,
		private ngxTranslateService: TranslateService,
		private $q: ng.IQService,
		private $document: ng.IDocumentService
	) {}

	public configure (language: Language) {
		this.$document[0].documentElement.setAttribute('lang', language);
		const ng1TranslatePromise = this.$translate.use(language);
		const ngxTranslatePromise = this.$q.when(lastValueFrom(this.ngxTranslateService.use(language)));
		this.tmhDynamicLocale.set(language);
		dayjs.locale(language);

		return this.$q.all({
			ng1TranslatePromise,
			ngxTranslatePromise
		});
	}

	public get longDateFormat () {
		return dayjs().localeData().longDateFormat('L');
	}

	public reset () {
		this.configure(Language.EN);
	}
}

export const goLocalizeHelperToken = upgradeNg1Dependency(GoLocalizeHelperService);
